import React from 'react';
import { Shield } from 'lucide-react';
export function Guarantee() {
  return <section className="py-12 md:py-20 bg-white" data-id="element-94">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-95">
        <div className="bg-ballet-50 border-2 border-ballet-200 rounded-3xl p-6 md:p-12 text-center transition-all duration-300 hover:shadow-md" data-id="element-96">
          <div className="inline-flex items-center justify-center w-16 h-16 md:w-20 md:h-20 rounded-full bg-white shadow-sm mb-4 md:mb-6" data-id="element-97">
            <Shield className="w-8 h-8 md:w-10 md:h-10 text-ballet-600" data-id="element-98" />
          </div>
          <h2 className="text-2xl md:text-3xl font-serif font-bold text-charcoal mb-4 md:mb-6" data-id="element-99">
            GARANZIA TOTALE DI 7 GIORNI
          </h2>
          <p className="text-base md:text-lg text-gray-700 leading-relaxed mb-4 md:mb-6" data-id="element-100">
            Il tuo denaro è protetto al 100%. Hai 7 giorni completi per aprire i
            volumi, provare i bonus nella tua sala e valutare ogni contenuto con
            le tue allieve. Se per qualsiasi motivo non sei completamente
            soddisfatta, ti rimborsiamo il 100% del denaro. Zero domande. Zero
            moduli. Zero problemi.
          </p>
          <p className="text-xs md:text-sm text-gray-500 font-medium" data-id="element-101">
            (Tasso di rimborsi inferiore all' 1%)
          </p>
        </div>
      </div>
    </section>;
}